import React from 'react';
import { View, StyleSheet } from 'react-native';
import Skeleton from '../common/Skeleton';

const ChatMessageSkeleton: React.FC = () => {
  return (
    <View style={styles.container}>
      <Skeleton width={200} height={16} borderRadius={16} />
      <View style={{ height: 8 }} />
      <Skeleton width={160} height={16} borderRadius={16} />
      <View style={{ height: 8 }} />
      <Skeleton width={180} height={16} borderRadius={16} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
});

export default ChatMessageSkeleton;
